/*
 *
 * File JS per la pagina di Archivio Blog
 *
 */

// IMPORT COMPONENTI
//--------------------------------------------------------------------//

import archiveFilters from "components/archive-filters/archive-filters";
import archiveList from "components/archive-list/archive-list";
import cardNews from "components/cards/card-news";

//--------------------------------------------------------------------//

// IMPORT STILE SPECIFICO PAGINA
//--------------------------------------------------------------------//

import "./archive.scss";

//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//

archiveFilters();

//--------------------------------------------------------------------//

// JS SPECIFICO PAGINA
//--------------------------------------------------------------------//

//--------------------------------------------------------------------//
